import api from '@/api'

export default {
  namespaced: true,
  
  state: {
    token: localStorage.getItem('token') || null,
    user: null,
    loginStep: 'email', // email -> password/code
    tempEmail: null,
    isNewUser: false
  },
  
  getters: {
    isAuthenticated: state => !!state.token,
    hasUserProfile: state => !!state.user,
    currentStep: state => state.loginStep,
    isNewUser: state => state.isNewUser,
    isAdmin: state => state.user?.role === 'admin'
  },
  
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      if (token) {
        localStorage.setItem('token', token)
      } else {
        localStorage.removeItem('token')
      }
    },
    SET_USER(state, user) {
      state.user = user
    },
    SET_LOGIN_STEP(state, step) {
      state.loginStep = step
    },
    SET_TEMP_EMAIL(state, email) {
      state.tempEmail = email
    },
    SET_IS_NEW_USER(state, isNew) {
      state.isNewUser = isNew
    }
  },
  
  actions: {
    // 检查邮箱是否存在
    async checkEmailOrPhone({ commit }, email) {
      const { data } = await api.post('/auth/checkExist', {
        identity: email
      })
      commit('SET_TEMP_EMAIL', email)
      commit('SET_IS_NEW_USER', !data.data)
      commit('SET_LOGIN_STEP', data.data ? 'password' : 'code')
      return data.data
    },
    
    // 发送验证码
    async sendCode({ state }) {
      await api.post('/auth/getCode', {
        mail: state.tempEmail
      })
    },
    
    // 密码登录
    async loginWithPassword({ commit }, { email, password }) {
      const { data } = await api.post('/auth/login', {
        email,
        password,
        platformType: 1
      })
      commit('SET_TOKEN', data.data)
      return data
    },
    
    // 验证码登录/注册
    async loginWithCode({ commit, state }, { email, code }) {
      const { data } = await api.post('/auth/loginByCode', {
        email,
        code,
        platformType: 1,
        isNewUser: state.isNewUser
      })
      commit('SET_TOKEN', data.data)
      return data
    },
    
    // 设置密码
    async setPassword({ state }, password) {
      const { data } = await api.post('/user/setPassword', {
        password
      })
      return data
    },
    
    // 获取用户信息
    async fetchUserProfile({ commit }) {
      const { data } = await api.get('/user/my/profile')
      commit('SET_USER', data.data)
      return data
    },
    
    // 登出
    logout({ commit }) {
      commit('SET_TOKEN', null)
      commit('SET_USER', null)
      commit('SET_LOGIN_STEP', 'email')
      commit('SET_TEMP_EMAIL', null)
      commit('SET_IS_NEW_USER', false)
    }
  }
} 